import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { EquipmentTypeService } from 'services/equipment-type-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class EquipmentTypeList {
  private tableData: Array<Models.EquipmentType>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private equipmentTypeService: EquipmentTypeService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('equipmentTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.equipmentTypeService
      .getAll('?$orderby=Name&$expand=NavisionProduct,DeltaProduct')
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('equipment-type-detail', { Id: id });
  }
}
